(function () {
  'use strict';

  var CFG = window.ATC_CAPTCHA;
  if (!CFG || !CFG.siteKey) return;
  if (window.__ATC_CAPTCHA_INIT) return;
  window.__ATC_CAPTCHA_INIT = true;

  var CACHE_KEY = '_atc_captcha_ok';
  var TTL      = CFG.ttlMs || 1800000;
  var SOFT_TTL = CFG.softTtlMs || 300000;
  var TIMEOUT  = CFG.timeoutMs || 20000;

  var originalFetch  = window.fetch ? window.fetch.bind(window) : null;
  var turnstileReady = false;
  var widgetId   = null;
  var readyToken = null;
  var waiters    = [];
  var inFlight   = null;
  var badge      = null;

  function log() {
    if (!CFG.debug || !window.console) return;
    console.log.apply(console, ['[ATC-CAPTCHA]'].concat([].slice.call(arguments)));
  }

  function isVerified() {
    try { return Number(sessionStorage.getItem(CACHE_KEY) || 0) > Date.now(); }
    catch (e) { return false; }
  }
  function markVerified(ms) {
    try { sessionStorage.setItem(CACHE_KEY, String(Date.now() + (ms || TTL))); } catch (e) {}
  }
  function isCartAdd(url) {
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url).split('#')[0]);
  }

  /* ---------------- visible badge ---------------- */

  function findAtcButton() {
    var main = document.getElementById('MainContent') || document;
    var all = main.querySelectorAll(
      '[name="add"], .product-form__submit, .btn--add-to-cart, [data-add-to-cart]'
    );
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null && all[i].getBoundingClientRect().height > 0) return all[i];
    }
    return null;
  }

  function buildBadge() {
    if (badge) return badge;
    var btn = findAtcButton();
    if (!btn || !btn.parentNode) { log('ATC button nahi mila'); return null; }

    badge = document.createElement('div');
    badge.className = 'atc-verify';
    badge.setAttribute('role', 'status');
    badge.innerHTML =
      '<span class="atc-verify__icon"></span>' +
      '<span class="atc-verify__text"></span>';
    btn.parentNode.insertBefore(badge, btn);

    var host = document.getElementById('atc-turnstile');
    if (host) badge.parentNode.insertBefore(host, badge.nextSibling);

    log('badge inserted above ATC');
    return badge;
  }

  function setState(state, text) {
    var b = buildBadge();
    if (!b) return;
    b.setAttribute('data-state', state);
    b.querySelector('.atc-verify__text').textContent = text;

    var btn = findAtcButton();
    if (btn) {
      if (state === 'checking') { btn.setAttribute('aria-disabled', 'true'); btn.disabled = true; }
      else { btn.removeAttribute('aria-disabled'); btn.disabled = false; }
    }
  }

  var S = CFG.strings || {};

  /* ---------------- turnstile ---------------- */

  function flush(token) {
    var list = waiters;
    waiters = [];
    list.forEach(function (w) { clearTimeout(w.timer); w.resolve(token); });
  }

  function onToken(token) {
    readyToken = token;
    log('token received');
    markVerified(TTL);
    stampCart((Date.now() + TTL) + '.local');
    setState('ok', S.verified || 'Verified — you are human');
    flush(token);
  }

  function onFail(why) {
    log('challenge failed:', why);
    readyToken = null;
    setState('ok', S.verified || 'Verified — you are human'); // fail-open, customer ko block nahi
    flush(null);
  }

  function renderWidget() {
    if (widgetId !== null || !turnstileReady || !window.turnstile) return;
    var el = document.getElementById('atc-turnstile');
    if (!el) { log('ERROR: #atc-turnstile div nahi hai'); return; }
    try {
      widgetId = window.turnstile.render(el, {
        sitekey: CFG.siteKey,
        appearance: 'interaction-only',
        execution: 'render',
        callback:           function (t) { onToken(t); },
        'error-callback':   function (c) { onFail(c); },
        'timeout-callback': function ()  { onFail('timeout'); },
        'expired-callback': function ()  { readyToken = null; }
      });
      log('widget rendered', widgetId);
    } catch (e) { log('render failed', e); }
  }

  window.atcTurnstileReady = function () {
    turnstileReady = true;
    log('turnstile loaded');
    renderWidget();
  };

  if (window.turnstile && typeof window.turnstile.render === 'function') {
    window.atcTurnstileReady();
  }
  /* ---------------- verification ---------------- */

  function stampCart(pass) {
    if (!CFG.stampCart || !originalFetch || !pass) return;
    originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _bp: pass } })
    }).catch(function () {});
  }

  function waitForToken() {
    return new Promise(function (resolve) {
      if (readyToken) return resolve(readyToken);
      if (!turnstileReady || !window.turnstile) return resolve(null);
      renderWidget();
      if (widgetId === null) return resolve(null);
      var w = { resolve: resolve };
      w.timer = setTimeout(function () {
        waiters = waiters.filter(function (x) { return x !== w; });
        resolve(null);
      }, TIMEOUT);
      waiters.push(w);
    });
  }

  function verify() {
    if (isVerified()) return Promise.resolve(true);
    if (inFlight) return inFlight;
    inFlight = waitForToken().then(function (token) {
      inFlight = null;
      if (token) return true;
      markVerified(SOFT_TTL);
      return true;
    }, function () { inFlight = null; markVerified(SOFT_TTL); return true; });
    return inFlight;
  }

  /* ---------------- interceptors ---------------- */

  if (originalFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isCartAdd(url)) return originalFetch.apply(null, arguments);
      var args = arguments;
      return verify().then(function (ok) {
        if (!ok) { showError(); return Promise.reject(new Error('atc_captcha_failed')); }
        return originalFetch.apply(null, args);
      });
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__atcUrl = url; return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this, args = arguments;
    if (!isCartAdd(xhr.__atcUrl)) return origSend.apply(xhr, args);
    verify().then(function (ok) {
      if (!ok) { showError(); try { xhr.abort(); } catch (e) {} return; }
      origSend.apply(xhr, args);
    });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !isCartAdd(form.action)) return;
    if (form.dataset.atcPassed === '1') { delete form.dataset.atcPassed; return; }
    if (isVerified()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    verify().then(function (ok) {
      if (!ok) return showError(form);
      form.dataset.atcPassed = '1';
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }, true);

  function showError(form) {
    var msg = S.failed || 'Verification failed. Please refresh the page and try again.';
    var el = (form || document).querySelector(
      '.product-form__error-message, .product-form__error-message-wrapper, .form__message'
    );
    if (el) { el.textContent = msg; el.hidden = false; el.style.display = ''; }
    else { window.alert(msg); }
  }

  /* ---------------- boot ---------------- */

  // function boot() {
  //   if (isVerified()) setState('ok', S.verified || 'Verified — you are human');
  //   else setState('checking', S.checking || 'Verifying you are human…');
  // }

    function boot() {
    if (isVerified()) { setState('ok', S.verified || 'Verified — you are human'); return; }
    setState('checking', S.checking || 'Verifying you are human…');
    setTimeout(function () {
      if (!readyToken && !isVerified()) {
        log('watchdog: no token after timeout, failing open');
        markVerified(SOFT_TTL);
        setState('ok', S.verified || 'Verified — you are human');
        flush(null);
      }
    }, TIMEOUT);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  log('initialised');
})();